<div class="hour-minute-wrapper">
  <input
    type="text"
    placeholder="HH"
    class="form-control hour"
    min="0"
    max="23"
    maxlength="2"
    [ngClass]="{'form-control': true, 'hour': true, 'invalid': !hour.valid }"
    [value]="hour.value"
    (change)="onInputChange(hour, $event)"
    (keyup)="onInputChange(hour, $event)"
  />
  <span class="hour-separator">:</span>
  <input
    type="text"
    placeholder="MM"
    min="0"
    max="59"
    maxlength="2"
    [disabled]="disableMinute"
    [ngClass]="{'form-control': true, 'minute': true, 'invalid': !minute.valid }"
    [value]="minute.value"
    (change)="onInputChange(minute, $event)"
    (keyup)="onInputChange(minute, $event)"
  />
  <div class="timezone-message">
    <label class="utc-notification">UTC</label>
    <label class="local-time"><span class="label"><span i18n="Text indicating the local time correspondend of a time input@@localTimeLabelSufixHourMinuteInput">Local time</span>: </span><span class="value">{{ localTime }}</span></label>
  </div>
  <select
    *ngIf="false"
    class="form-control timezone"
    (change)="onInputChange(timezone, $event)"
    [value]="timezone.value"
    (change)="onInputChange(timezone, $event)"
    (keyup)="onInputChange(timezone, $event)"
  >
    <option value="UTC">UTC</option>
    <option value="BRT">BRT</option>
  </select>
</div>
